var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4126 19.1911L9.80555 18.5579C6.84993 15.4756 6.23463 11.6962 8.23434 8.91378C9.11883 7.68917 9.52262 6.17021 9.36605 4.66236L8.98424 0.691406L10.0006 1.81327C12.687 4.77899 13.2474 8.32786 11.4564 11.0131L11.135 11.4963C10.3577 12.657 10.0006 14.0538 10.1187 15.4478L10.4126 19.1911Z",
    fill: "#E47A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4832 18.7491L17.0025 18.2493C14.6622 15.8112 14.176 12.8205 15.7582 10.6184C16.4587 9.6465 16.7773 8.44966 16.6537 7.25282L16.3543 4.10938L17.1591 4.99798C19.2852 7.34445 19.7302 10.1547 18.3128 12.279L18.0573 12.6622C17.442 13.5786 17.1591 14.6838 17.2552 15.789L17.486 18.7491H17.4832Z",
    fill: "#E47A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44134 18.7497L2.96064 18.2499C0.623064 15.809 0.13687 12.8211 1.71906 10.6162C2.41951 9.6443 2.73815 8.44746 2.61454 7.25062L2.31238 4.10718L3.11721 4.99578C5.24328 7.34226 5.68828 10.1525 4.2709 12.2768L4.01544 12.66C3.40289 13.5764 3.11721 14.6816 3.21335 15.7868L3.44409 18.7497H3.44134Z",
    fill: "#E47A47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.7ed445a9b7dc9443e52b487826e9b859.svg";
export { ForwardRef as ReactComponent };